// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';

import { PolicyService } from '@app/core';
import {
  PolicyStatementActionTypes,
  LoadingPolicyStatementServicesAction,
  CompleteLoadPolicyStatementServicesAction,
  FailLoadPolicyStatementServicesAction,
  LoadingPolicyStatementResourceActionsAction,
  CompleteLoadPolicyStatementResourceActionsAction,
  FailLoadPolicyStatementResourceActionsAction
} from './policy-statement.actions';

@Injectable()
export class PolicyStatementEffects {
  @Effect()
  requestOnLoadStatementServices$ = this.actions$.pipe(
    ofType<LoadingPolicyStatementServicesAction>(PolicyStatementActionTypes.SERVICES_LOADING),
    flatMap(action => this.requestServices())
  );

  @Effect()
  requestOnLoadStatementResourceActions$ = this.actions$.pipe(
    ofType<LoadingPolicyStatementResourceActionsAction>(PolicyStatementActionTypes.RESOURCE_ACTIONS_LOADING),
    flatMap(action => this.requestResourceActions(action.payload))
  );

  constructor(private actions$: Actions, private policyService: PolicyService) {}

  private requestServices(): Observable<
    CompleteLoadPolicyStatementServicesAction | FailLoadPolicyStatementServicesAction
  > {
    return this.policyService.getServices().pipe(
      map(services => new CompleteLoadPolicyStatementServicesAction({ services })),
      catchError(_ => of(new FailLoadPolicyStatementServicesAction()))
    );
  }

  private requestResourceActions({
    serviceId
  }: {
    serviceId: string;
  }): Observable<CompleteLoadPolicyStatementResourceActionsAction | FailLoadPolicyStatementResourceActionsAction> {
    return this.policyService.getResourceActions(serviceId).pipe(
      map(resourceActions => new CompleteLoadPolicyStatementResourceActionsAction({ serviceId, resourceActions })),
      catchError(_ => of(new FailLoadPolicyStatementResourceActionsAction({ serviceId })))
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/policy-statement.effects.ts